import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';

/** Section 10 — who it is for. */
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-34" data-mp="1y9er5lhv0udg">
      <div className="mx-auto max-w-4xl" data-id="element-35" data-mp="1t7z3rms7mbrw">
        <SectionHeading id="audience-heading" title={<>
              Is Makeup Instructor Ready <Accent data-id="element-37" data-mp="238hun1i6ysjb">For You?</Accent>
            </>} body="Yes, if you are a:" data-id="element-36" data-mp="286t1d3d6wmxb" />

        <ul className="mt-10 grid gap-x-12 border-t border-brand-charcoal/12 sm:grid-cols-2" role="list" data-id="element-38" data-mp="2gy1rjqp3cvkp">
          {audience.map(item => <li key={item} className="flex items-start gap-3 border-b border-brand-charcoal/12 py-4 text-[15px] leading-snug text-brand-charcoal" data-id="element-39" data-mp="2czm7nvob43bi">
              <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-40" data-mp="2m00ux0ktzshn" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-41" data-mp="1xbgnwr224mmq">
          You don't need another generic makeup ebook.{' '}
          <Accent data-id="element-42" data-mp="26cwyaysvgoqy">You need a system that helps you turn what you know into organized, teachable education.</Accent>
        </p>
      </div>
    </section>;
}